import {AppState} from './context';
import {userStorage} from './user';

const RETURNS_SETTINGS_KEY = `ordersReturnsSettings`;

class OrdersReturnsSettingsStorage {
    getUserLogin = (): string => {
        return `${RETURNS_SETTINGS_KEY}_${userStorage.get()?.login}` || RETURNS_SETTINGS_KEY;
    };

    set = (config: AppState['orders']['returnsConfig']) =>
        localStorage.setItem(this.getUserLogin(), JSON.stringify(config));

    get = (): AppState['orders']['returnsConfig'] | null => {
        const storedConfig = localStorage.getItem(this.getUserLogin());
        return storedConfig ? JSON.parse(storedConfig) : null;
    };

    clear = () => localStorage.removeItem(this.getUserLogin());
}

export const ordersReturnsSettingsStorage = new OrdersReturnsSettingsStorage();
